import { DefaultProductOptions } from '../analytics-context-types';
import { getModalTag, getPODProductTag } from './utils';

/**
 * Gets the modal and product tag to track when user gets a low resolution image toast
 *
 * @param options attributes to be included in product tag and modal event tag
 * @returns
 */
export const lowResImageToastTag = (options: DefaultProductOptions) => {
  const lowResPhotoEvent = [
    {
      eventInfo: {
        eventName: 'photo',
        eventAction: 'photo resolution',
      },
    },
  ];

  const { product } = getPODProductTag(
    options.productName,
    options.productID,
    options.productType,
    options.productQuantity,
  );

  const { modal, user } = getModalTag(options.productType, 'TEST Mode', lowResPhotoEvent, options.projectID);

  return {
    modal,
    product,
    user,
  };
};
